
<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="isVisibleCustomerOrderDetail"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'800px'}">
    <ng-template pTemplate="header">
        <div class="flex flex-row">
            <div class="verification-head">
                <div class="verification-head__title">TX ID: {{transactionId}}</div>
            </div>
        </div>
    </ng-template>
    <div>
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <div *ngIf="showSpinner" class="transaction-detail-loading">
            <spinner></spinner>
        </div>

        <ng-container *ngIf="transaction">
            <ng-container *ngIf="activeMenuTab === menuTab.OrderDetails">
                <div class="customer-info-body">
                    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                                   [styleClass]="'app-scrollpanel'">
                        <div>
                            <div class="transaction-info-title">Xpress Transaction</div>
                            <div class="flex flex-row flex-wrap">
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">
                                        <div class="col-6 p-0 mb-2">Transaction date:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.TransactionDate}}</div>

                                        <div class="col-6 p-0 mb-2">Transaction type:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.TransactionTypeText}}</div>
                                    </div>
                                </div>
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">

                                        <div class="col-6 p-0 mb-2">Transaction time:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.TransactionTime}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="transaction-info-title">Products & Services</div>
                            <div class="flex flex-row flex-wrap">
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">
                                        <div class="col-6 p-0 mb-2">Service:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.DeliveryServiceTypeText}} | {{transaction.DeliveryVehicleTypeText}}</div>

                                        <div class="col-6 p-0 mb-2">Distance:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.DeliveryDistanceInM}}</div>

                                        <div class="col-6 p-0 mb-2">Duration:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.DeliveryDurationInSec}}</div>

                                        <div class="col-6 p-0 mb-2">Order time:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.AcceptedAtTime}}</div>

                                        <div class="col-6 p-0 mb-2">Completed time:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.DeliveryCompletedAtTime}}</div>
                                    </div>
                                </div>
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">

                                        <div class="col-6 p-0 mb-2">Products:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.Products || 'N/A'}}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="transaction-info-title">Customer Promotions</div>
                            <div class="flex flex-row flex-wrap">
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">
                                        <div class="col-6 p-0 mb-2">Promo used?:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.LocalOrderPromoUsed ? 'Yes' : 'No'}}</div>

                                        <div class="col-6 p-0 mb-2">Promo Amount:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.LocalOrderPromoAmount || 'N/A'}}</div>
                                    </div>
                                </div>
                                <div class="col-6 p-0">
                                    <div class="flex flex-row flex-wrap">
                                        <div class="col-6 p-0 mb-2">Promo:</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">{{transaction.LocalOrderPromoCode || 'N/A'}}</div>

                                        <div class="col-6 p-0 mb-2">Promo funding</div>
                                        <div class="col-6 p-0 mb-2 transaction-value">
                                            {{(transaction.PromoOrderFunded) ? transaction.PromoOrderFunded : 'N/A'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="transaction-info-title">Payment</div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Base fare:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.XpressDeliveryOrderBaseFare || 'N/A'}}</div>

                                    <div class="col-6 p-0 mb-2">Distance:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.XpressDeliveryOrderDistanceFare || 'N/A'}}</div>

                                    <div class="col-6 p-0 mb-2">Time:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.OrderTripDurationCharge || 'N/A'}}</div>

                                    <div class="col-6 p-0 mb-2">Surge Charges:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.XpressDeliveryOrderSurgeFactor || 'N/A'}}</div>

                                    <div class="col-6 p-0 mb-2">Toll:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.XpressDeliveryOrderTollsAmount || '—'}}</div>

                                    <div class="col-6 p-0 mb-2">Ride Insurance Opt-in:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.RiderInsuranceAmount || 'N/A'}}</div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Partner TX ID:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">—</div>

                                    <div class="col-6 p-0 mb-2">Transaction Status:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span *ngIf="transaction.IsPaid" class="transaction-color-green">Success</span>
                                        <span *ngIf="!transaction.IsPaid">Unsuccessfully</span>
                                    </div>

                                    <div class="col-6 p-0 mb-2">Payment method:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.PaymentMethodText || '—'}}</div>

                                    <div class="col-6 p-0 mb-2">Transaction amount:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.TransactionAmount}}</div>

                                    <div class="col-6 p-0 mb-2">Tip:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">—</div>
                                </div>
                            </div>
                        </div>

                        <div class="transaction-info-title">Corresponding Identifiers</div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Booking ID:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{transaction.XpressOrderId || '—'}}</div>

                                    <div class="col-6 p-0 mb-2">Order ID:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">—</div>
                                </div>
                            </div>
                        </div>

                    </p-scrollPanel>
                    <ng-container *ngIf="transaction.IsPaid">
                        <div class="flex justify-content-end">
                            <div>
                                <button pButton pRipple type="button" label="Refund" class="p-button btn-refund"></button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <div class="customer-info-body" *ngIf="activeMenuTab === menuTab.Messages">
                <div class="transaction-info-title">Driver and Customer Messages</div>
                <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                               [styleClass]="'app-scrollpanel'">

                    <div *ngIf="transaction.Messages">

                        <div class="message-outer-block" *ngFor="let message of transaction.Messages">
                            <div class="message-inner-block-left">
                                <div *ngIf="message.MessageTypeId === chatMessageTypeEnum.RiderToCustomer">
                                    <div class="message-author">{{message.RiderName}}</div>
                                    <div class="message-border-left-block message-text-left">{{message.Message}}</div>
                                    <div class="message-date" style="text-align: right;">{{message.CreatedAt}}</div>
                                </div>
                            </div>
                            <div class="message-inner-block-right">
                                <div *ngIf="message.MessageTypeId === chatMessageTypeEnum.CustomerToRider">
                                    <div style="text-align:right" class="message-author">Customer: {{message.UserName}}</div>
                                    <div class="message-border-right-block message-text-right">{{message.Message}}</div>
                                    <div class="message-date">{{message.CreatedAt}}</div>
                                </div>
                            </div>
                        </div>

                    </div>

                </p-scrollPanel>
            </div>

            <div class="customer-info-body" *ngIf="activeMenuTab === menuTab.Timeline">
                <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                               [scrollLeft]="false"
                               [styleClass]="'app-scrollpanel'">

                    <div>
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="lm-active-order-details-main-block">
                                        <div class="transaction-info-title">Order Timeline</div>
                                        <div class="lm-active-order-details-field-block">
                                            <div class="lm-active-order-details-field-name">Priority:</div>
                                            <div *ngIf="!transaction.IsPriority">Normal</div>
                                            <div *ngIf="transaction.IsPriority" class="transaction-color-green fw-5" style="">Priority</div>
                                        </div>
                                        <p *ngIf="transaction.statusId === orderRiderActionEnum.ForceAssigned" class="transaction-color-red fw-5">Force Assigned by Admin</p>
                                        <div class="lm-active-order-details-field-block">
                                            <div class="lm-active-order-details-field-name">Session Time:</div>
                                            <div class="lm-active-order-details-field-value">{{orderStats?.SessionTime}}</div>
                                        </div>
                                        <div style="display: flex;" class="lm-active-order-details-field-block">
                                            <div class="lm-active-order-details-field-name">Attempts:</div>
                                            <div class="lm-active-order-details-attempts">
                                                <div class="lm-active-order-details-field-value">{{ orderStats?.AttemptsCount }}</div>
                                                <div style="margin-top: 8px;width: 110%;">
                                                    <ng-container *ngIf="orderStats?.RiderActions">
                                                        <ng-container *ngFor="let item of orderStats.RiderActions">
                                                            <div class="flex">
                                                                <div class="lm-active-order-details-attempt-item">{{ item.CreatedTime }}</div>
                                                                <div class="lm-active-order-details-attempt-item">{{ item.VehicleTypeStr }}</div>
                                                                <div class="lm-active-order-details-attempt-item">
                                                                    <span [class]="(item.RiderAction === 'Accept') ? 'green-color' : ''">{{ item.RiderAction }}</span>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="lm-active-order-details-main-block">
                                        <div class="transaction-info-title"></div>
                                        <div class="grid-list">
                                            <div class="grid-list-item">
                                                <div class="grid-list-item-marker bc-green">

                                                </div>
                                                <div class="grid-list-item-text">
                                                    Time Accepted
                                                </div>
                                                <div class="grid-list-item-text">
                                                    {{transaction.TimeAccepted}}
                                                </div>
                                                <div class="grid-list-item-stick">

                                                </div>
                                            </div>
                                            <div class="grid-list-item">
                                                <div class="grid-list-item-marker bc-dark-blue">

                                                </div>
                                                <div class="grid-list-item-text">
                                                    Time Arrival on Pick up point
                                                </div>
                                                <div class="grid-list-item-text">
                                                    {{transaction.TimeArrivalPickup}}
                                                </div>
                                                <div class="grid-list-item-stick">

                                                </div>
                                            </div>
                                            <div class="grid-list-item">
                                                <div class="grid-list-item-marker bc-red">

                                                </div>
                                                <div class="grid-list-item-text">
                                                    Time Arrival on Drop off
                                                </div>
                                                <div class="grid-list-item-text">
                                                    {{ transaction.CompletedAt }}
                                                </div>
                                                <div class="grid-list-item-stick">

                                                </div>
                                            </div>
                                            <div class="grid-list-item">
                                                <div class="grid-list-item-marker bc-blue">

                                                </div>
                                                <div class="grid-list-item-text">
                                                    Time of Drop off
                                                </div>
                                                <div class="grid-list-item-text">
                                                    {{ transaction.CompletedAt }}
                                                </div>
                                                <div class="grid-list-item-stick">

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-scrollPanel>
            </div>
        </ng-container>
    </div>
</p-sidebar>
